import { render, staticRenderFns } from "./Btn.vue?vue&type=template&id=b8d0aa46"
import script from "./Btn.vue?vue&type=script&lang=js"
export * from "./Btn.vue?vue&type=script&lang=js"
import style0 from "./Btn.vue?vue&type=style&index=0&id=b8d0aa46&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports